module.exports = __webpack_public_path__ + "images/backgrounds/cosmos/small.0646808c900b7409dbeb.jpg";